import { render } from "./ModalInformativoInvestidor.vue?vue&type=template&id=4a83a1d9"
import script from "./ModalInformativoInvestidor.vue?vue&type=script&lang=js"
export * from "./ModalInformativoInvestidor.vue?vue&type=script&lang=js"

import "./ModalInformativoInvestidor.vue?vue&type=style&index=0&id=4a83a1d9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__